import React from 'react'
import {css} from '@emotion/core'
import theme from 'prism-react-renderer/themes/nightOwl'
// import theme from 'prism-react-renderer/themes/nightOwlLight'
// import theme from 'prism-react-renderer/themes/github'
import Highlight, {defaultProps} from 'prism-react-renderer'
import {bpDesktopOnly} from '../../lib/breakpoints'

const RE = /{([\d,-]+)}/

const wrapperStyles = css`
  overflow: auto;
  ${bpDesktopOnly} {
    margin-left: -50px;
    margin-right: -50px;
  }
`

const preStyles = css`
  float: left;
  min-width: 100%;
  overflow: auto;
  background-color: #383838 !important;
`

function calculateLinesToHighlight(meta) {
  if (RE.test(meta)) {
    const lineNumbers = RE.exec(meta)[1]
      .split(',')
      .map(v => v.split('-').map(y => parseInt(y, 10)))
    return index => {
      const lineNumber = index + 1
      const inRange = lineNumbers.some(([start, end]) =>
        end ? lineNumber >= start && lineNumber <= end : lineNumber === start,
      )
      return inRange
    }
  } else {
    return () => false
  }
}

function Code({codeString, language, metastring}) {
  const shouldHighlightLine = calculateLinesToHighlight(metastring)
  return (
    <Highlight
      {...defaultProps}
      code={codeString}
      language={language}
      theme={theme}
    >
      {({className, style, tokens, getLineProps, getTokenProps}) => (
        <div css={wrapperStyles}>
          <pre className={className} style={style} css={preStyles}>
            {tokens.map((line, i) => (
              <div
                key={i}
                {...getLineProps({
                  line,
                  key: i,
                  className: shouldHighlightLine(i) ? 'highlight-line' : '',
                })}
              >
                <span
                  css={css`
                    display: inline-block;
                    width: 2em;
                    user-select: none;
                    opacity: 0.3;
                  `}
                >
                  {i + 1}
                </span>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({token, key})} />
                ))}
              </div>
            ))}
          </pre>
        </div>
      )}
    </Highlight>
  )
}

export default Code
